
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'

interface FormState {
  email: string;
}

export default defineComponent({
  setup () {
    const route = useRoute()
    const api = process.env.VUE_APP_BASEURL
    const loading = ref<boolean>(false)
    const isValidCode = ref<boolean>(false)
    const isInvalidCode = ref<boolean>(false)
    const email = ref<string>('')
    const currentYear = (new Date()).getFullYear()

    const index = async () => {
      loading.value = true
      isValidCode.value = false
      isInvalidCode.value = false

      await axios.post(`${api}auth/reset_password`, { code: route.query.code }).then((res) => {
        isValidCode.value = true
        loading.value = false
        email.value = res.data.data[0]
      }).catch((e: any) => {
        isInvalidCode.value = false
        loading.value = false
      })
    }

    onMounted(index)

    return {
      loading,
      isValidCode,
      isInvalidCode,
      email,
      currentYear
    }
  },
})
